﻿import { WFS as WFSFormat, GML as GMLFormat, WKT, GeoJSON } from 'ol/format';
import Circle from 'ol/geom/Circle.js';
import Feature from 'ol/Feature.js';
import Collection from 'ol/Collection.js';
import { Utility } from '../Utility.js';
export { GreenAreaTool };

/**
 * Class GreenAreaTool
 */
const GreenAreaTool = function () {

    // Define this
    var myGreenAreaTool = this;

    // -- begin private variable ------------------------------------------------------------------

    // Map
    this._mapSgs = null;

    // Utility
    this._utility = new Utility();

    // Already initialize
    this._toolInitialize = false;

    // Hash that contains all reference 
    this._hashReference = {};

    // Feature to save
    this._featureInfo = null;

    // Geojson Format
    this._geojsonFormat = new GeoJSON();

    // Occurrences table counter/id
    this._plantasRowCounter = 0;

    // Layer green area name
    this._LayerGreenAreaName = "";

    // -- end private variable ------------------------------------------------------------------

    // -- begin public variable ------------------------------------------------------------------

    // feature colection use in green area tool
    this.collectionFeatureSet = new Collection();

    // -- end public variable ------------------------------------------------------------------

    // -- begin private method ------------------------------------------------------------------

    /**
     * Compare
     */
    this._Compare = function (a, b) {
        const posA = a.column_pos;
        const posB = b.column_pos;

        let comparison = 0;
        if (posA > posB) {
            comparison = 1;
        } else if (posA < posB) {
            comparison = -1;
        }

        return comparison;
    }

    /**
    * Get all references for green area tool
    */
    this._GetAllReferences = function () {
        $.ajax({
            type: 'GET',
            url: '/rest/app/GreenAreaTool/GetAllReference',
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro de carregamento da informação de referência");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            myGreenAreaTool._hashReference['plantas_list'] = data.result.list_plantas;
                            myGreenAreaTool._hashReference['tipo_espaco_verde_list'] = data.result.list_tipos_espaco_verde;
                            myGreenAreaTool._hashReference['arruamentos_list'] = data.result.list_arruamentos;
                            myGreenAreaTool._hashReference['numeros_policia_list'] = data.result.list_numeros_policia;

                            //myGreenAreaTool._utility.FillSelect('id-pubtoolType', data.result.list_tipos_publicidade, 'value', 'id', true);
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro de carregamento da informação de referência");
                            break;
                        default:
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro de carregamento da informação de referência");
            }
        });

        myGreenAreaTool._hashReference['freguesia_list'] = [];

        if (myGreenAreaTool._mapSgs._hashReference['freguesia'] === undefined) {
            myGreenAreaTool._mapSgs._GetAllReference();
        };
    };

    /**
     * Save green area
     */
    this._SaveFeature = function ()
    {
        myGreenAreaTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);

        let idEspacoVerdeValue = $("#prop_IDGEVESPACOVERDE").val();
        let espacoVerdeValue = $("#prop_GEVESPACOVERDE").val();
        let idTipoValue = $("#prop_IDGEVTIPOESPACOVERDE").val();
        let idFreguesiaValue = $("#prop_IDFREGUESIA").val();
        let idArruamentoValue = $("#prop_IDARRUAMENTO").val();
        let idNumeroPoliciaValue = $("#prop_IDNUMEROPOLICIA").val();
        let observacoesValue = $("#prop_OBSERVACOES").val();

        let geom_wkt = new WKT().writeGeometry(myGreenAreaTool._featureInfo.feature.getGeometry());
        let geom_srid = myGreenAreaTool._mapSgs._settings.projection.getCode().replace('EPSG:', '');

        let plantas = myGreenAreaTool._hashReference['plantas_rows'];

        let greenAreaSaveFields = {
            idEspacoVerde: idEspacoVerdeValue,
            espacoVerde: espacoVerdeValue,
            idTipo: idTipoValue,
            idFreguesia: idFreguesiaValue,
            idArruamento: idArruamentoValue,
            idNumeroPolicia: idNumeroPoliciaValue,
            observacoes: observacoesValue,
            plantas: plantas,
            geom_wkt: geom_wkt,
            geom_srid: geom_srid
        };

        $.ajax({
            type: 'POST',
            url: '/rest/app/GreenAreaTool/SaveGreenArea',
            data: JSON.stringify(greenAreaSaveFields),
            dataType: 'json',
            contentType: "application/json",
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na criação do espaço verde");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            // Refresh green area layer
                            myGreenAreaTool._RefreshLayerGreenArea();

                            // Close edition
                            myGreenAreaTool._mapSgs.layerTree.CloseEdition(false);

                            toastr["success"]("Espaço verde criado com sucesso");
                            myGreenAreaTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
                            break;
                        default:
                            toastr["error"]("Erro na criação do espaço verde");
                            myGreenAreaTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na criação do espaço verde");
                myGreenAreaTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            }
        });
    };

    /**
     * Get Freguesia Info from point
     */
    this._GetFreguesiaInfoFromPoint = function (featurePoint) {
        var featureReturn = null;

        // Get point geojson
        var pointCoord = null;
        if (featurePoint.getGeometry().getCoordinates()[0][0] instanceof Array)
            pointCoord = turf.point(featurePoint.getGeometry().getCoordinates()[0][0]);
        else
            pointCoord = turf.point(featurePoint.getGeometry().getCoordinates());

        myGreenAreaTool.collectionFeatureSet.getArray().forEach(function (featureIn, index) {
            if (featureIn.getId().indexOf("FREGUESIA") >= 0) {
                var featureInGeoJson = myGreenAreaTool._geojsonFormat.writeFeatureObject(featureIn);
                if (turf.booleanPointInPolygon(pointCoord, featureInGeoJson)) {
                    // Get feature freguesia info
                    featureReturn = featureIn;
                }
            }
        });

        return featureReturn;
    };

    /**
     * Search green area
     */
    this._SearchGreenAreas = function () {
        myGreenAreaTool._utility.ShowWait('offcanvas-map-spinner', true);

        // Build Filter
        var cqlFilter = "";
        var greenArea = $('#id-greenAreaToolGreenArea').val();
        var freguesia = $('#id-greenAreaToolFreguesia').val();

        if (greenArea !== "") {
            var query = `GEVESPACOVERDE = '${greenArea}'`;
            cqlFilter = query;
        }

        if (freguesia !== "") {
            var query = `IDFREGUESIA = ${freguesia}`;

            if (cqlFilter === "") {
                cqlFilter = query;
            } else {
                cqlFilter = `${cqlFilter} AND ${query}`;
            }
        }

        // Get features
        var layerName = myGreenAreaTool._LayerGreenAreaName;
        var layerInfo = myGreenAreaTool._mapSgs.layerTree.FindLayerInfo(layerName);
        var getFeatureUrl = layerInfo.geoserver + "/wfs";
        var workspace = layerInfo.workspace;
        var cqlFilterLayer = layerInfo.cqlFilter;
        var cqlFilterResult = cqlFilter;
        if (cqlFilterLayer)
            cqlFilterResult += " And " + cqlFilterLayer;

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: true,
            url: getFeatureUrl,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": workspace + ':' + myGreenAreaTool._LayerGreenAreaName,
                "cql_filter": cqlFilterResult,
                "outputFormat": 'application/json'
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {
            if (data.features) {
                if (data.features.length > 0) {
                    if (myGreenAreaTool._mapSgs.featureToHighLight.getLength() > 0)
                        myGreenAreaTool._mapSgs.featureToHighLight.clear();

                    myGreenAreaTool._mapSgs._arraySearchLayerFeatureActive = [];

                    var feature = null;
                    var layerName = myGreenAreaTool._LayerGreenAreaName;
                    var idLayer = myGreenAreaTool._mapSgs.layerTree.FindLayerInfo(layerName).id;
                    var workspace = myGreenAreaTool._mapSgs.layerTree.FindLayerInfo(layerName).workspace;

                    var columnDefArray = [];
                    var columDefArrayExpand = [];
                    var columDefArrayExpandSize = [];
                    var columnValueArray = [];
                    var idPrimaryKey = null;
                    var featureHash = {};

                    for (let i = 0; i < data.features.length; i++) {
                        feature = (new GeoJSON()).readFeatures(data)[i];
                        idPrimaryKey = feature.getId().split(".")[1];
                        featureHash[idPrimaryKey] = feature;

                        // Save feature Search
                        myGreenAreaTool._mapSgs._arraySearchLayerFeatureActive.push(feature);

                        // Build column info
                        var objRow = {};
                        for (var j = 0; j < Object.keys(feature.getProperties()).length; j++) {
                            var columnName = Object.keys(feature.getProperties())[j];

                            if (columnName === "geometry")
                                continue;

                            var value = feature.getProperties()[columnName];
                            var columnProperties = myGreenAreaTool._mapSgs.layerTree.layerInfo.dict_layer_info[idLayer].list_column.filter(obj => {
                                return obj.column_name === columnName
                            })[0];

                            // If value is a system date, format string
                            //if (new Date(value) != 'Invalid Date' && isNaN(value))
                            if (columnProperties) {
                                if (columnProperties.column_type == 'xsd:date-time')
                                    value = myGreenAreaTool._utility.TransformDateServerInDateTime(value);

                                objRow[columnName] = value;
                                if (columDefArrayExpandSize[columnName]) {
                                    if (value) {
                                        var valueSize = value.toString().length;
                                        columDefArrayExpandSize[columnName] = (valueSize > columDefArrayExpandSize[columnName]) ? valueSize : columDefArrayExpandSize[columnName];
                                    }
                                }
                                else {
                                    if (value)
                                        columDefArrayExpandSize[columnName] = value.toString().length;
                                    else
                                        columDefArrayExpandSize[columnName] = 30; // If fist empty
                                }
                                if (i === 0) {
                                    var columnSearchResult = myGreenAreaTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).search_result;
                                    var visible = myGreenAreaTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).visible;
                                    var columnPrettyName = myGreenAreaTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).pretty_name;
                                    var searchResultOrder = myGreenAreaTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).search_result_order;

                                    if (columnSearchResult) {
                                        columnDefArray.push({
                                            'data': columnName,
                                            'title': columnPrettyName,
                                            'name': columnPrettyName,
                                            'label': columnPrettyName,
                                            'type': columnPrettyName,
                                            'orderable': false,
                                            'width': '30px',
                                            'search_order': searchResultOrder
                                        });
                                    } else {
                                        columnDefArray.push({
                                            'data': columnName,
                                            'type': 'readonly',
                                            'visible': false,
                                            'search_order': 0
                                        });
                                    }
                                    if (visible) {
                                        columDefArrayExpand.push({
                                            'data': columnName,
                                            'title': columnPrettyName,
                                            'name': columnPrettyName,
                                            'label': columnPrettyName,
                                            'type': columnPrettyName,
                                            'orderable': false,
                                            'width': '30px'
                                        });
                                    }
                                    else {
                                        columDefArrayExpand.push({
                                            'data': columnName,
                                            'type': 'readonly',
                                            'visible': false
                                        });
                                    }
                                }
                            }
                        }
                        // Order columns by search order
                        columnDefArray = columnDefArray.sort((a, b) => (a.search_order > b.search_order) ? 1 : -1);

                        // Add primary key value
                        objRow["id_primary_key"] = idPrimaryKey;

                        // Add array row
                        columnValueArray.push(objRow);

                        // Put in feature highlight
                        myGreenAreaTool._mapSgs.featureToHighLight.push(feature);
                        var styleElement = myGreenAreaTool._mapSgs._defaultHighlighStyles;
                        myGreenAreaTool._mapSgs.featureToHighLight.getArray()[myGreenAreaTool._mapSgs.featureToHighLight.getArray().length - 1].setStyle(styleElement);
                    }

                    // Add primary key to array
                    columnDefArray.push({
                        'data': "id_primary_key",
                        'type': 'readonly',
                        'visible': false
                    });

                    columDefArrayExpand.push({
                        'data': "id_primary_key",
                        'type': 'readonly',
                        'visible': false
                    });

                    // Add size to column in array expand
                    for (let i = 0; i < columDefArrayExpand.length; i++) {
                        var objDef = columDefArrayExpand[i];
                        if (objDef.width) {
                            if (columDefArrayExpandSize[objDef.data] > 50)
                                objDef.width = columDefArrayExpandSize[objDef.data].toString() + "px";
                            else
                                objDef.width = "50px";
                            columDefArrayExpand[i] = objDef;
                        }
                    };

                    // Show canvas search result
                    myGreenAreaTool._utility.ShowOpenCanvas3('offcanvas-search-result', true);

                    // Make datatable list
                    myGreenAreaTool._mapSgs.InitSearchResultTable(workspace, layerName, idLayer, featureHash, columnDefArray, columDefArrayExpand, columnValueArray, myGreenAreaTool.DetailElement);

                    // Go to Feature
                    myGreenAreaTool._mapSgs.map.getView().fit(myGreenAreaTool._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myGreenAreaTool._mapSgs.map.getSize() });

                    // Remove hide in offcanvas search result information
                    $('#id-offcanvas-search-result-zone').removeClass('ol-hidden');
                    $('#id-offcanvas-search-result-body').removeClass('ol-hidden');
                }
                else {
                    toastr["warning"]("Não foi encontrada, nenhuma camada");
                }
            };

            // Stop wait
            myGreenAreaTool._utility.ShowWait('offcanvas-map-spinner', false);
        });
    };


    /**
     * Refresh green area layer
     */
    this._RefreshLayerGreenArea = function()
    {
        // Refresh all route layer
        var layerInfo = myGreenAreaTool._mapSgs.layerTree.FindLayerInfo(myGreenAreaTool._LayerGreenAreaName);
        var layer = myGreenAreaTool._mapSgs._utility.GetLayerByName(myGreenAreaTool._mapSgs.map, layerInfo.layerNameKey);
        layer.getSource().clear();
    }

    // -- end private method --------------------------------------------------------------------

    // -- begin public method -------------------------------------------------------------------

    /**
     * Fill hash freguesia
     * @param {array} freguesiasData, array of freguesia
     */
    this.FillFreguesiaList = function (freguesiasData) {
        freguesiasData.forEach(x => {
            myGreenAreaTool._hashReference['freguesia_list'].push({ "id": x.IDFREGUESIA, "value": x.FREGUESIA });
        });

        myGreenAreaTool._utility.FillSelect('id-greenAreaToolFreguesia', myGreenAreaTool._hashReference['freguesia_list'], 'value', 'id', true);
    };

    /**
     * Build detail information
     * @param {object} featureInfo, all information of the pub
     */
    this.DetailElement = function (featureInfo) {
        myGreenAreaTool._featureInfo = featureInfo;

        myGreenAreaTool._hashReference['plantas_rows'] = [];
        var codElement = "";

        // Start wait
        myGreenAreaTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);

        // Clean Number of file
        $('.offcanvas-body-layer-detail-attachment-info-td span')[0].innerHTML = "-";

        // Define according to mode
        var readOnly = "readonly";
        var hiddenCol = false;
        switch (featureInfo.mode) {
            case 'update':
                $('#id-offcanvas-body-layer-detail-button').removeClass('ol-hidden');
                $('#id-save-feature-submit').off('click').on('click', function () {
                    myGreenAreaTool._SaveFeature('update', app.Select.getFeatures().getArray()[0]);
                });
                readOnly = "";
                break;
            case 'create':
                $('#id-offcanvas-body-layer-detail-button').removeClass('ol-hidden');
                $('#id-save-feature-submit').off('click').on('click', function () {
                    myGreenAreaTool._SaveFeature();
                });
                readOnly = "";
                break;
            default: // read
                $('#id-offcanvas-body-layer-detail-button').addClass('ol-hidden');
        }

        // Show canvas
        myGreenAreaTool._utility.ShowOpenCanvas3('id-offcanvas-layer-detail', true);

        // Layer info
        var layerObj = myGreenAreaTool._mapSgs.layerTree.layerInfo.dict_layer_info[featureInfo.idLayer];
        var layerName = layerObj.layer_info.layerName;
        var layerPrettyName = layerObj.layer_info.pretty_name;

        // Get codElement
        if (featureInfo.feature.getProperties().import_code)
            codElement = featureInfo.feature.getProperties().import_code;

        // Build title
        $('#id-offcanvas-head-title-element')[0].innerHTML = layerObj.layer_info.pretty_name;
        $('#id-offcanvas-head-code-element')[0].innerHTML = codElement;

        // -- Fields -------------------------------------------------------------------------------
        $('#id-offcanvas-body-layer-detail-field').empty();

        var gpName = myGreenAreaTool._mapSgs.getSettings()._mapSettings.search_toponymy.workspaceSearchToponymy;

        layerObj.list_column.sort(myGreenAreaTool._Compare);

        // Build Info field
        for (var i = 0; i < layerObj.list_column.length; i++) {
            var objColumn = layerObj.list_column[i];

            // Show only if field marked as visible
            if (!objColumn.visible) continue;

            // Show only if field marked as editable for creations
            if (!objColumn.editable && featureInfo.mode == 'create') continue;

            if (objColumn.editable && (featureInfo.mode == 'update' || featureInfo.mode == 'create')) {
                readOnly = '';
                if (featureInfo.mode == 'update' && (objColumn.column_name == 'zone' || objColumn.column_name == 'id_zone')) {
                    readOnly = 'readonly'; // Cannot update zone in model (Update DB procedures to change this)
                }
            } else {
                readOnly = 'readonly';
            }

            // Change condition according to GP to not include ID fields (myTooltips._mapSgs.getSettings()._mapSettings.search_toponymy.workspaceSearchToponymy == 'GP_MEALHADA')
            //if (objColumn.column_name !== 'geom' && objColumn.column_name !== 'GEOMETRY ' && objColumn.column_name.substr(0, 2).toUpperCase() !== 'ID') {
            if ((objColumn.column_name !== 'geom' && objColumn.column_name !== 'GEOMETRY ' && objColumn.column_name.substr(0, 6).toUpperCase() === 'ID_REF')
                || (objColumn.column_name !== 'geom' && objColumn.column_name !== 'GEOMETRY ')) {

                let value = featureInfo.feature.getProperties()[objColumn.column_name];

                let isIdCol = false;
                let isRefCol = false;
                let codUniverseTable = "";

                switch (objColumn.column_name) {
                    case "IDGEVESPACOVERDE":
                        isIdCol = true;
                        break;
                    case "IDGEVTIPOESPACOVERDE":
                        isRefCol = true;
                        codUniverseTable = "tipo_espaco_verde_list";
                        break;
                    case "IDFREGUESIA":
                        isRefCol = true;
                        codUniverseTable = "freguesia_list";
                        break;
                    case "IDARRUAMENTO":
                        isRefCol = true;
                        codUniverseTable = "";
                        break;
                    case "IDNUMEROPOLICIA":
                        isRefCol = true;
                        codUniverseTable = "";
                        break;
                    default:
                        break;
                };

                if (isIdCol) {
                    hiddenCol = true;
                } else if (gpName == 'GP_PONTA_DELGADA' && objColumn.column_name == 'DATA') {
                    hiddenCol = true; // Hide column DATA for PONTA DELGADA creations
                    value = myGreenAreaTool._utility.getNewDateForServer();
                } else {
                    hiddenCol = false;
                }

                if (value === null || value === undefined)
                    value = '';

                // Act according column type
                switch (objColumn.column_type) {
                    case "xsd:date-time":
                        value = myGreenAreaTool._utility.TransformDateServerInDateII(value);
                        break;
                    default:
                    // do nothing
                }

                var comboArray = [];
                var prefix = "id_";
                if (isRefCol) {
                    comboArray = myGreenAreaTool._hashReference[codUniverseTable];
                    prefix = "";
                }

                // Check if there is an associated field with a id_ prefix to add combo boxes
                if (isRefCol) {
                    var defValue = "";

                    if (value != "") {
                        if (typeof comboArray == "undefined" && objColumn.column_name === "IDARRUAMENTO") {
                            comboArray = myGreenAreaTool._hashReference["arruamentos_list"];
                        } else if (typeof comboArray == "undefined" && objColumn.column_name === "IDNUMEROPOLICIA") {
                            comboArray = myGreenAreaTool._hashReference["numeros_policia_list"];
                        }

                        if (comboArray.length > 0) {
                            defValue = comboArray.filter(function (ob) { return ob.id == value; })[0];

                            if (featureInfo.mode == 'read') {
                                defValue = defValue.value;
                            } else {
                                defValue = defValue.id;
                            }
                        }
                    }

                    // Fill rule for field
                    //switch (objColumn.column_name) {
                    //    case "IDFREGUESIA":
                    //        var featureFreguesia = myGreenAreaTool._GetFreguesiaInfoFromPoint(myGreenAreaTool._featureInfo.feature);
                    //        if (featureFreguesia !== null)
                    //            defValue = featureFreguesia.getProperties().IDFREGUESIA;
                    //        break;
                    //    default:
                    //        break;
                    //}

                    // In read mode, add text box for ID_REF
                    if (featureInfo.mode == 'read') {

                        $('#id-offcanvas-body-layer-detail-field').append($(
                            '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + '">'
                            + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                            + '<input class=" feature-field form-control ' + objColumn.column_type + '" data-name="' + prefix + objColumn.column_name + '" type="text" id="prop_' + prefix + objColumn.column_name + '" value="' + defValue + '" ' + readOnly + '/>'
                            + '</div > '
                        ));

                    } else {

                        var disabled = readOnly == 'readonly' ? 'disabled' : '';
                        // Add select box with associated entity possible values
                        $('#id-offcanvas-body-layer-detail-field').append($(
                            '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + '">'
                            + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                            + '<select title="Nenhum escolhido" class="feature-field form-control ' + objColumn.column_type + '" id="prop_assoc_' + objColumn.column_name + '" data-name= "' + objColumn.column_name + '" data-destination-field="prop_' + prefix + objColumn.column_name + '" ' + disabled + '><option></option></select>'
                            + '</div > '
                        ));

                        myGreenAreaTool._utility.FillSelect("prop_assoc_" + objColumn.column_name, comboArray, 'value', 'id');

                        $('#' + 'prop_assoc_' + objColumn.column_name).selectpicker('val', defValue);

                        // Add field that contains ID for associated entity
                        $('#id-offcanvas-body-layer-detail-field').append($(
                            '<div class="form-group offcanvas-body-layer-detail-row hidden">'
                            + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                            + '<input class=" feature-field form-control ' + objColumn.column_type + '" data-name="' + prefix + objColumn.column_name + '" type="text" id="prop_' + prefix + objColumn.column_name + '" value="' + defValue + '" ' + readOnly + '/>'
                            + '</div > '
                        ));
                    }
                } else {
                    $('#id-offcanvas-body-layer-detail-field').append($(
                        '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + '">'
                        + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                        + '<input class=" feature-field form-control ' + objColumn.column_type + '" data-name="' + objColumn.column_name + '" type="text" id="prop_' + objColumn.column_name + '" value="' + value + '" ' + readOnly + '/>'
                        + '</div > '
                    ));
                }
            }
        };

        let container = $("#mCSB_8_container");

        // -- Plantas -------------------------------------------------------------------------------
        $('#id-offcanvas-body-layer-plantas').remove();
        myGreenAreaTool._plantasRowCounter = 0;

        let plantasContent = '<div id="id-offcanvas-body-layer-detail-plantas" class="offcanvas-block" style="display: none;">'
            + '<button type="button" class="btn btn-primary" id="id-offcanvas-body-layer-detail-plantas-btn-add-planta" style="margin-bottom: 5px;">Inserir Planta</button>'
            + '<div id="prop_planta_add_planta_div" class="form-group offcanvas-body-layer-detail-row hidden">'
            + '<label for="prop_planta_add_planta">Planta</label>'
            + '<select title="Nenhum escolhido" class="feature-field form-control xsd:string" id="prop_planta_add_planta"><option></option></select>'
            + '</div>'
            + '<div id="prop_planta_add_data_div" class="form-group offcanvas-body-layer-detail-row hidden">'
            + '<label for="prop_planta_add_data">Data Colocação</label>'
            + '<input class="feature-field form-control xsd:string" id="prop_planta_add_data" type="date" value="">'
            + '</div>'
            + '<div id="prop_planta_add_quantidade_div" class="form-group offcanvas-body-layer-detail-row hidden">'
            + '<label for="prop_planta_add_quantidade">Quantidade</label>'
            + '<input class="feature-field form-control xsd:string" id="prop_planta_add_quantidade" type="number" value="">'
            + '</div>'
            + '<div id="prop_planta_add_observacoes_div" class="form-group offcanvas-body-layer-detail-row hidden">'
            + '<label for="prop_planta_add_observacoes">Observações</label>'
            + '<input class="feature-field form-control xsd:string" id="prop_planta_add_observacoes" value="">'
            + '</div>'
            + '<div id="prop_planta_add_buttons_div" class="form-group offcanvas-body-layer-detail-row hidden">'
            + '<button type="button" class="btn btn-primary" id="id-offcanvas-body-layer-detail-plantas-btn-add-planta-close" style="margin: 0 2px;">Fechar</button>'
            + '<button type="button" class="btn btn-primary" id="id-offcanvas-body-layer-detail-plantas-btn-add-planta-add" style="margin: 0 2px;">Inserir</button>'
            + '</div>'
            + '<div class="table-responsive">'
            + '<table id="id-planta-table" class="table" table-hover>'
            + '<thead><tr><th scope="col">Planta</th><th scope="col">Data</th><th scope="col">Quantidade</th></tr></thead>'
            + '<tbody id="id-offcanvas-body-layer-detail-plantas-table-body">'
            + '</tbody>'
            + '</table>'
            + '</div>'
            + '</div>';

        container.append('<div id="id-offcanvas-body-layer-plantas" class="row margin-top-lg offcanvas-body-layer-detail">'
            + '<div class="col-md-12">'
            + '<div>'
            + '<div target-id="id-offcanvas-body-layer-detail-plantas" class="offcanvas-collapse">'
            + '<i class="fa option-title-go-right-open fa-chevron-down"></i>'
            + '<label>Plantas</label>'
            + '</div>'
            + plantasContent
            + '</div>'
            + '<div class="offcanvas-separator"></div>'
            + '</div>'
            + '</div>');

        myGreenAreaTool._utility.FillSelect("prop_planta_add_planta", myGreenAreaTool._hashReference['plantas_list'], 'value', 'id');

        // Add Intervenção click
        $('#id-offcanvas-body-layer-detail-plantas-btn-add-planta').off('click').on('click', function () {
            $("#prop_planta_add_planta_div").removeClass("hidden");
            $("#prop_planta_add_data_div").removeClass("hidden");
            $("#prop_planta_add_quantidade_div").removeClass("hidden");
            $("#prop_planta_add_observacoes_div").removeClass("hidden");
            $("#prop_planta_add_buttons_div").removeClass("hidden");
        });

        // Close Add Intervenção click
        $('#id-offcanvas-body-layer-detail-plantas-btn-add-planta-close').off('click').on('click', function () {
            $("#prop_planta_add_planta_div").addClass("hidden");
            $("#prop_planta_add_planta").val("");
            $("#prop_planta_add_data_div").addClass("hidden");
            $("#prop_planta_add_data").val("");
            $("#prop_planta_add_quantidade_div").addClass("hidden");
            $("#prop_planta_add_quantidade").val("");
            $("#prop_planta_add_observacoes_div").addClass("hidden");
            $("#prop_planta_add_observacoes").val("");
            $("#prop_planta_add_buttons_div").addClass("hidden");
        });

        // Confirm Add Intervenção click
        $('#id-offcanvas-body-layer-detail-plantas-btn-add-planta-add').off('click').on('click', function () {
            let plantaValue = $("#prop_planta_add_planta option:selected").text();
            let plantaId = $("#prop_planta_add_planta").val();
            let dataValue = $("#prop_planta_add_data").val();
            let quantidadeValue = $("#prop_planta_add_quantidade").val();
            let observacoesValue = $("#prop_planta_add_observacoes").val();

            if (observacoesValue === "" && quantidadeValue === "" && plantaId === "" & dataValue === "") {
                $("#id-offcanvas-body-layer-detail-plantas-btn-add-planta-close").click();
                return;
            }

            if (dataValue !== "") {
                let dataValues = dataValue.split('-');
                dataValue = `${dataValues[2]}/${dataValues[1]}/${dataValues[0]}`;
            }

            if (plantaValue == "Nenhum escolhido")
                plantaValue = "";

            myGreenAreaTool._plantasRowCounter++;
            var rowId = myGreenAreaTool._plantasRowCounter;
            var trId = `id-row-${rowId}`;
            var anchorId = `id-anchor-${rowId}`;

            let newContent = `<tr id="${trId}"><td class="hidden">${rowId}</td><td>${plantaValue}</td><td class="hidden">${plantaId}</td><td>${dataValue}</td><td>${quantidadeValue}</td><td><i><a id="${anchorId}" href="#" title="Remoção"><i class="material-icons">delete</i></a></i></td></tr>`;

            myGreenAreaTool._hashReference['plantas_rows'].push({ "id": rowId, "planta": plantaId, "data": dataValue, "quantidade": quantidadeValue, "observacoes": observacoesValue });

            let tableBody = $("#id-offcanvas-body-layer-detail-plantas-table-body");
            tableBody.append(newContent);

            $("#prop_planta_add_planta_div").addClass("hidden");
            $("#prop_planta_add_planta").val("");
            $("#prop_planta_add_data_div").addClass("hidden");
            $("#prop_planta_add_data").val("");
            $("#prop_planta_add_quantidade_div").addClass("hidden");
            $("#prop_planta_add_quantidade").val("");
            $("#prop_planta_add_observacoes_div").addClass("hidden");
            $("#prop_planta_add_observacoes").val("");
            $("#prop_planta_add_buttons_div").addClass("hidden");

            $(`#${anchorId}`).off('click').on('click', function () {
                let arrayId = trId.split('-')[2];

                $(`#${trId}`).remove();

                myGreenAreaTool._hashReference['plantas_rows'] = myGreenAreaTool._hashReference['plantas_rows'].filter(function (element) {
                    return element.id != arrayId;
                });
            });
        });

        // -- Intervenções -------------------------------------------------------------------------------
        $('#id-offcanvas-body-layer-intervencoes').remove();

        let intervencoesContent = '<div id="id-offcanvas-body-layer-detail-intervencoes" class="offcanvas-block" style="display: none;">'
            + '<div class="form-group offcanvas-body-layer-detail-row">'
            + '</div>'
            + '</div>';

        container.append('<div id="id-offcanvas-body-layer-intervencoes" class="row margin-top-lg offcanvas-body-layer-detail">'
            + '<div class="col-md-12">'
            + '<div>'
            + '<div target-id="id-offcanvas-body-layer-detail-intervencoes" class="offcanvas-collapse">'
            + '<i class="fa option-title-go-right-open fa-chevron-down"></i>'
            + '<label>Intervenções</label>'
            + '</div>'
            + intervencoesContent
            + '</div>'
            + '<div class="offcanvas-separator"></div>'
            + '</div>'
            + '</div>');

        // -- Mobiliário Urbano -------------------------------------------------------------------------------
        $('#id-offcanvas-body-layer-mobiliario-urbano').remove();

        let mobiliarioUrbanoContent = '<div id="id-offcanvas-body-layer-detail-mobiliario-urbano" class="offcanvas-block" style="display: none;">'
            + '<div class="form-group offcanvas-body-layer-detail-row">'
            + '</div>'
            + '</div>';

        container.append('<div id="id-offcanvas-body-layer-mobiliario-urbano" class="row margin-top-lg offcanvas-body-layer-detail">'
            + '<div class="col-md-12">'
            + '<div>'
            + '<div target-id="id-offcanvas-body-layer-detail-mobiliario-urbano" class="offcanvas-collapse">'
            + '<i class="fa option-title-go-right-open fa-chevron-down"></i>'
            + '<label>Mobiliário Urbano</label>'
            + '</div>'
            + mobiliarioUrbanoContent
            + '</div>'
            + '<div class="offcanvas-separator"></div>'
            + '</div>'
            + '</div>');

        // Add values and behaviours to combo boxes
        $('select.feature-field').each(function () {
            var comboBox = $(this);
            var destinationText = comboBox.data('destination-field');
            comboBox.on('change', function () {
                // Update respective id field for db update
                $('#' + destinationText).val($(this).val());
            });
        });

        // Refresh collapse elements
        $('.offcanvas-collapse').off('click').on('click', function () {
            var idNodeToCollapse = this.getAttribute('target-id');
            $(this).find('i').toggleClass('fa-chevron-down fa-chevron-up');
            // Close all other info

            $('#' + idNodeToCollapse).toggle('ol-hidden');
        });

        // -- File --------------------------------------------------------------------------------

        // Init Upload for entity
        if (myGreenAreaTool._mapSgs._uploadAttachtment)
            myGreenAreaTool._mapSgs._uploadAttachtment.LoadAttachment(featureInfo.id, layerName, 'id-offcanvas-body-layer-detail-attachment-zone', 'id-offcanvas-body-layer-detail-attachment-form', 'id-offcanvas-body-layer-detail-attachment-add', 'offcanvas-body-layer-detail-attachment-info-td', 'id-offcanvas-body-layer-detail-attachment-spinner');

        $('#prop_assoc_IDFREGUESIA').on('changed.bs.select', function () {
            $("#prop_assoc_IDARRUAMENTO").empty();

            let selectedValue = this.value;

            let arruamentosList = myGreenAreaTool._hashReference['arruamentos_list'];

            let filteredArruamentos = arruamentosList.filter(function (el) {
                return el.idFreguesia === selectedValue;
            });

            myGreenAreaTool._utility.FillSelect("prop_assoc_IDARRUAMENTO", filteredArruamentos, 'value', 'id');
        });

        $('#prop_assoc_IDARRUAMENTO').on('changed.bs.select', function () {
            $("#prop_assoc_IDNUMEROPOLICIA").empty();

            let selectedValue = this.value;

            let arruamentosList = myGreenAreaTool._hashReference['arruamentos_list'];

            let idFreguesiaTroco = arruamentosList.filter(function (el) {
                return el.id === selectedValue;
            })[0].idFreguesiaTroco;

            let numerosPoliciaList = myGreenAreaTool._hashReference['numeros_policia_list'];

            let filteredNumerosPolicia = numerosPoliciaList.filter(function (el) {
                return el.idFreguesiaTroco === idFreguesiaTroco;
            });

            myGreenAreaTool._utility.FillSelect("prop_assoc_IDNUMEROPOLICIA", filteredNumerosPolicia, 'value', 'id');
        });

        // Stop wait
        myGreenAreaTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
    };

    /**
     * Clean detail
     */
    this.CleanDetail = function () {
        // -- Plantas -------------------------------------------------------------------------------
        $('#id-offcanvas-body-layer-plantas').remove();
        // -- Intervenções -------------------------------------------------------------------------------
        $('#id-offcanvas-body-layer-intervencoes').remove();
        // -- Mobiliário Urbano -------------------------------------------------------------------------------
        $('#id-offcanvas-body-layer-mobiliario-urbano').remove();
    }

    // -- end public method --------------------------------------------------------------------

    // -- begin event --------------------------------------------------------------------------

    $('#id-buttonsearchGreenAreaTool').on('click', function () {
        myGreenAreaTool._SearchGreenAreas();
    });

    // -- end event ----------------------------------------------------------------------------
};

/**
 * Init green area tool
 * @param {object} mapSgs, map object
 */
GreenAreaTool.prototype.Init = function (mapSgs) {
    if (!this._toolInitialize) {
        this._toolInitialize = true;

        // Set map info
        this._mapSgs = mapSgs;

        // Get layer green area name
        this._LayerGreenAreaName = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "GREEN_AREA_TOOL", "LAYER_INFO", "LAYER_NAME").value;

        // -- Get all references -----------------------------------------------------------------
        this._GetAllReferences();
    }
};